 $(document).ready(function() {
   
   $('.lm-index-slider img').on('load', function() {
	$('.lm-index-slider').removeClass('loading').removeClass('loading--delayed');
    $('.lm-index-slider .slick-list').css('transform','scale(1)');    
	});
   $(document).on('click', '.lm-index-slider .slick-slide', function () {
     var link = $('.lm-index-slider .slick-current').attr('data-link');    
     location.href = link;
   });
   
   $('.lm-index-slider').slick({       
        autoplay: true,
    	autoplaySpeed: 750,
     	speed:550,
       	cssEase: 'ease-in-out',
     	pauseOnFocus: false,
        pauseOnHover: false,
    	fade: true,     
        slidesToShow: 1,
      	swipe: false,     	
        slidesToScroll: 1,     
        infinite: true      
    });  
});